import DataLayer from '../dataLayer';

export default class FavsTracker {

    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
        this.pages = window.__pt.fn.analytics.pages;
        this.fn = window.__pt.fn || {}
    }

    async logAddFav(item,origin) {
        const params = {
            event: this.events.gtmEvent,
            eventName: 'favs_add',
            eventCategory: this.events.hotels,
            eventAction: origin.toString(),
            eventLabel: `${item.id} :: ${item.name}`,
            eventExtra: origin+"|"+ item.uri,
        };
        this.analytics.set(this.events.gtmEvent, params);
    }

    async logDeleteFav(item, origin) {
        const params = {
            event: this.events.gtmEvent,
            eventName: '"favs_delete"',
            eventCategory: this.events.hotels,
            eventAction: origin.toString(),
            eventLabel: `${item.id} :: ${item.name}`,
            eventExtra: origin + "|" + item.uri,
        };
        this.analytics.set(this.events.gtmEvent, params);
    }

    async logOpenFav(item, origin, count) {
        const fecha_1 = item.checkin ? this.fn.getDate(item.checkin) : "";
        const fecha_2 = item.checkout ? this.fn.getDate(item.checkout) : "";
        let type = "=";
        if (item.totalRoomRatePerNight < item.originalPrice) {
            type = "bajó";
        } else if (item.totalRoomRatePerNight > item.originalPrice) {
            type = "subió";
        }
        const params = {
            event: this.events.gtmEvent,
            eventName: 'favs_open_item',
            eventCategory: this.events.hotels,
            eventAction: origin.toString(),
            eventLabel: `${item.id} :: ${item.name} :: ${fecha_1}-${fecha_2}`,
            eventExtra: `${type} :: ${count}`,
        };
        this.analytics.set(this.events.gtmEvent, params);
    }

    async logOpenFavsList(origin, quantity ) {
        const params = {
            event: this.events.trackEvent,
            eventName: 'favs_open_list',
            eventCategory: this.events.hotels,
            eventAction: origin.toString(),
            eventLabel: `${quantity}`,
            eventExtra: ''
        };
        this.analytics.set(this.events.gtmEvent, params);
    }
}
